// extracted by mini-css-extract-plugin
module.exports = {"phonePrefixItem":"PhonePrefixItem_phonePrefixItem__Ngb53"};